// Add your custom JS here.

(function($) {

  // to-top
  $(function() {
      let showFlag = false;
      const topBtn = $('.to-top');    
      topBtn.css('bottom', '-100px');
      //スクロールが100に達したらボタン表示
      $(window).on('scroll', function () {
          if ($(this).scrollTop() > 100) {
              if (showFlag == false) {
                  showFlag = true;
                  topBtn.stop().animate({'bottom' : '30px'}, 200); 
              }
          } else {
              if (showFlag) {
                  showFlag = false;
                  topBtn.stop().animate({'bottom' : '-100px'}, 200); 
              }
          }
      });

      topBtn.on('click', function(){
        $('body,html').animate({
          scrollTop: 0},500);
          return false;
      });
        
  });


  // page-link-scroll
  $(function() {
    let headerHeight = 0;
    headerHeight = $('#main-nav').outerHeight();
    let urlHash = window.location.hash;
    if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function () {
        scrollToAnker(urlHash);
      }, 100);
    }
    $('a.link-scroll, a.nav-link').on('click', function(){
      let href= $(this).attr('href').replace(/.*#/, '');
      let hash = '#' + href;
      scrollToAnker(hash);
      return false;
    })
    function scrollToAnker(hash) {
      let target = $(hash);
      if(target.length){
        let position = target.offset().top - headerHeight;
        $('body,html').stop().animate({scrollTop:position}, 500, 'linear');
        return false;
      }
    }
  })



  // main-nav スクロール処理
  $(function() {
    const navBar = $('#main-nav');
    $(window).on('load scroll', function() {
      if ($(this).scrollTop() > 400 && navBar.hasClass('nav-scrolled') == false) {
        navBar.css({'top': '-100px'});
        navBar.addClass('nav-scrolled');
        navBar.animate({'top': 0},500);
      } else if($(this).scrollTop() < 200 && navBar.hasClass('nav-scrolled') == true) {
        navBar.removeClass('nav-scrolled');
      }
    });
  })


  
  // カテゴリー 検索
  $(function() {
    if ( $('.in-category-search.searched')[0] ) {
      const position = $('.in-category-search.searched').eq(0).offset().top - 150;
      $('body,html').delay(200).animate({scrollTop:position}, 600, 'swing');
    }
  })




})(jQuery);


